(function () {
  /* Controller */
  SUGApp.controller('enterpriseController', enterpriseController);

  enterpriseController.$inject = ["$scope", 'SUGUtilities', '$sce', '$q', 'enterpriseService'];

  function enterpriseController($scope, SUGUtilities, $sce, $q, enterpriseService) {

    // Initialize scope variables
    $scope.success = false;
    $scope.strMessage = '';
    $scope.feature_preference_array = [];
    $scope.captchaSnippet = '';
    $scope.recaptchafeature = '';
    $scope.formSubmitted = false;

    $scope.formData = {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      company: '',
      feature_preference: [],
      hutk: '',
      'g-recaptcha-response': ''
    };

    $scope.features = [
      { name: 'custom_landing_page', label: 'Custom landing page' },
      { name: 'white_labeling', label: 'White labeling' },
      { name: 'embed_sign_up', label: 'Embed sign up' },
      { name: 'dedicated_support', label: 'Dedicated support' },
      { name: 'more_twenty_admins', label: 'More than 20 administrators' }
    ];

    /* Initialize reCaptcha */
    function init() {
      SUGUtilities.getReCaptcha({})
        .then(function (response) {
          var r = SUGUtilities.lowerCaseKeys(response);
          if (!SUGUtilities.ajaxResultInvalid(r.data)) {
            $scope.captchaSnippet = $sce.trustAsHtml(r.data.data.snippet);
            $scope.recaptchafeature = r?.data?.data?.feature;
          }
        });
    }

    /* Append Attribution Params */
    function appendAttributionParamToForm(paramName, paramValue) {
      var elInput = angular.element('<input type="hidden">');
      // Set attributes using .attr() which is similar to jQuery's API
      elInput.attr('name', paramName);
      elInput.attr('value', paramValue);
      // Append the input element to the form using angular.element
      angular.element('enterprisecontactform').append(elInput);
    }

    /* Process URL or Cookie Attribution Data */
    $scope.processAttributionData = function () {
      var attAttributionParams = [
        'utm_source', 'utm_medium', 'utm_campaign', 
        'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid'
      ];

      var currUrlParams = new URLSearchParams(window.location.search);
      var urlAttributionParamsFound = false;

      attAttributionParams.forEach(function (item) {
        var currAttributionParamValue = currUrlParams.get(item);
        if (currAttributionParamValue) {
          urlAttributionParamsFound = true;
          appendAttributionParamToForm(item, currAttributionParamValue);
        }
      });

      if (!urlAttributionParamsFound) {
        var attributionCookie = utility.getCookie('MATTRIBUTION');
        if (attributionCookie.length) {
          var currCookieParams = JSON.parse(decodeURIComponent(attributionCookie));
          if (Array.isArray(currCookieParams)) {
            attAttributionParams.forEach(function (item) {
              var currAttributionParamValue = currCookieParams[0][item];
              if (currAttributionParamValue) {
                appendAttributionParamToForm(item, currAttributionParamValue);
              }
            });
          }
        }
      }
    };

    /* Submit Enterprise Form */
    $scope.submitForm = function () {
      $scope.formSubmitted = true;
      $scope.formData['g-recaptcha-response'] = document.getElementById('enterprisecontactform')["g-recaptcha-response"].value;

      var formData = {
        submitted: '',
        firstname: $scope.formData.firstname,
        lastname: $scope.formData.lastname,
        email: $scope.formData.email,
        phone: $scope.formData.phone,
        company: $scope.formData.company,
        hutk: $scope.formData.hutk,
        feature_preference: $scope.feature_preference_array,
      };

      if($scope.formData['g-recaptcha-response']){
        formData['g-recaptcha-response'] = $scope.formData['g-recaptcha-response']
      }

      enterpriseSubmit(formData);
    };

    /* Handle Enterprise Form Submission */
    function enterpriseSubmit(formData) {
      enterpriseService.enterpriseSubmit(formData)
        .then(function (response) {
            var r = SUGUtilities.lowerCaseKeys(response.data);
            $scope.success =  r.success;
            $scope.strMessage = r.message;
            $scope.toggleContactForm();
          if (typeof $scope.success !== 'undefined' && $scope.success) {
            // Ensure this is a production environment and the IP is not a support IP
            if (!SUGUtilities.isPreProductionEnvironment() && !SUGUtilities.isSupportIP()) {
          
              // Google Ads (gtag.js) script
              var gtagScript = document.createElement('script');
              gtagScript.async = true;
              gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-877246914&l=thirdPartyDataLayer";
              document.head.appendChild(gtagScript);
          
              gtagScript.onload = function () {
                window.thirdPartyDataLayer = window.thirdPartyDataLayer || [];
                function gtag() { thirdPartyDataLayer.push(arguments); }
                gtag('js', new Date());
                gtag('config', 'AW-877246914');
              };
          
              // Google Ads conversion event snippet for Enterprise Contact Form
              window.sugTagManager.pushConversionEvent({
                event: "conversion",
                sendTo: "AW-877246914/kw_DCPfbgYoDEMLzpqID"
              });
          
              // Bing Ads conversion tracking
              (function uet_report_conversion() {
                window.uetq = window.uetq || [];
                window.uetq.push({ event: "enterprise_submit_lead_form" });
              })();
          
              // Facebook Pixel
              (function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
              })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          
              utility.isVendorAllowed('facebook').then(function (vendorResult) {
                if (!vendorResult.allowed) {
                  fbq('consent', 'revoke');
                }
              });
          
              fbq('init', '1696408607309042');
              fbq('track', 'PageView');
              fbq('track', 'Lead');
          
              // Facebook Pixel NoScript Fallback
              var fbImg = document.createElement('img');
              fbImg.height = 1;
              fbImg.width = 1;
              fbImg.style.display = 'none';
              fbImg.src = 'https://www.facebook.com/tr?id=1696408607309042&ev=PageView&noscript=1';
              document.body.appendChild(fbImg);
          
              // Capterra Pixel tracking
              utility.isVendorAllowed('capterra').then(function (vendorResult) {
                if (vendorResult.allowed) {
                  var capterraImg = document.createElement('img');
                  capterraImg.src = 'https://ct.capterra.com/capterra_tracker.gif?vid=2095332&vkey=eea96217aab93b4cd8f88d664ac3c6e5';
                  document.createElement('span').appendChild(capterraImg);
                }
              });
          
            }
          }


         
        });
    }

    /* Toggle Features (Mutually Exclusive) */
    $scope.toggleFeature = function (feature, exclusive) {
      if (exclusive) {
        $scope.feature_preference_array = [];
      }
      const index = $scope.feature_preference_array.indexOf(feature);
      if (index === -1) {
        $scope.feature_preference_array.push(feature);
      } else {
        $scope.feature_preference_array.splice(index, 1);
      }
    };

    /* Scroll to Contact Form */
    $scope.toggleContactForm = function () {
      setTimeout(function () {
        var targetElement = $(".form-holder");
        var elementTop = targetElement.offset().top;
        $('html, body').animate({ scrollTop: elementTop - 150 }, 1500);
      }, 450);
    };

    /* Scroll to Features */
    $scope.slideToFeatures = function () {
      setTimeout(function () {
        $("html, body").animate({ scrollTop: $("#plan-features").offset().top }, 1200);
      }, 450);
    };

    /* Toggle Free or Premium/Enterprise Sliders */
    $scope.showCategory = function (category) {
      $scope.section = category;
    };

    // Handle URL-based category toggle
    if (window.location.href.indexOf("enterprise") > -1 && window.location.href.indexOf("enterprisecontact") === -1) {
      $scope.showCategory("premium");
    } else if (window.location.href.indexOf("free") > -1) {
      $scope.showCategory("free");
    } else if (window.location.hash === "#/enterprisecontact") {
      $scope.toggleContactForm();
    }

    // Display promo banner using jQuery
    jQuery(".promoBanner").slideDown("slow");

    // Initialize captcha and other data
    init();
    $scope.processAttributionData();
  }
})();
